export const  domain = window.location.hostname === "localhost" ?'http://localhost:5500' :'https://api.meducate.ai'
export const domainUrl = (path) => {
    return domain+path
}
